module.exports = __webpack_public_path__ + "img/steak-3.eb014830.png";